import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      // Navigation
      "nav.dashboard": "Dashboard",
      "nav.portfolio": "Portfolio",
      "nav.trade": "Trade",
      "nav.liveTrading": "Live Trading",
      "nav.charts": "Charts",
      "nav.bigMovers": "Big Movers",
      "nav.signalBots": "Signal Bots",
      "nav.gridBots": "Grid Bots",
      "nav.dcaBots": "DCA Bots",
      "nav.smartTrades": "SmartTrades",
      "nav.paperTrading": "Paper Trading",
      "nav.aiStrategy": "AI Strategy",
      "nav.analytics": "Analytics+",
      "nav.backtesting": "Backtesting",
      "nav.performance": "Performance",
      "nav.copyTrading": "Copy Trading",
      "nav.settings": "Settings",
      "nav.rebalance": "Rebalance",
      "nav.marketplace": "Marketplace",
      "nav.journal": "Journal",
      "nav.referrals": "Referrals",
      "nav.admin": "Admin Panel",

      // Common
      "common.loading": "Loading...",
      "common.save": "Save",
      "common.cancel": "Cancel",
      "common.delete": "Delete",
      "common.edit": "Edit",
      "common.search": "Search",
      "common.noData": "No data available",
      "common.success": "Success",
      "common.error": "Error",
      "common.confirm": "Confirm",
      "common.back": "Back",
      "common.next": "Next",
      "common.close": "Close",
      "common.refresh": "Refresh",
      "common.active": "Active",
      "common.inactive": "Inactive",

      // Dashboard
      "dashboard.title": "Dashboard",
      "dashboard.welcome": "Welcome back",
      "dashboard.totalBalance": "Total Balance",
      "dashboard.todayPnl": "Today's P&L",
      "dashboard.totalTrades": "Total Trades",
      "dashboard.winRate": "Win Rate",
      "dashboard.activeBots": "Active Bots",

      // Trading
      "trading.buy": "Buy",
      "trading.sell": "Sell",
      "trading.market": "Market",
      "trading.limit": "Limit",
      "trading.amount": "Amount",
      "trading.price": "Price",
      "trading.placeOrder": "Place Order",
      "trading.orderPlaced": "Order placed successfully",
      "trading.orderFailed": "Order failed",
      "trading.openOrders": "Open Orders",
      "trading.tradeHistory": "Trade History",
      "trading.pair": "Trading Pair",
      "trading.side": "Side",
      "trading.orderType": "Order Type",
      "trading.stopLoss": "Stop Loss",
      "trading.takeProfit": "Take Profit",
      "trading.trailingStop": "Trailing Stop",
      "trading.oco": "OCO",
      "trading.realMoney": "REAL MONEY",
      "trading.paperMode": "Paper Trading Mode",
      "trading.liveMode": "Live Trading Mode",

      // Live Trading
      "liveTrade.title": "Live Trading",
      "liveTrade.subtitle": "Execute real trades on your connected exchanges",
      "liveTrade.noExchanges": "No Exchanges Connected",
      "liveTrade.noExchangesDesc": "Connect your exchange API keys in Settings to start live trading.",
      "liveTrade.goToSettings": "Go to Settings",
      "liveTrade.autoRefresh": "Auto-Refresh",
      "liveTrade.selectExchange": "Select Exchange",
      "liveTrade.balance": "Balance",
      "liveTrade.realWarning": "This will execute a REAL trade with REAL funds",

      // Order Book
      "orderBook.title": "Order Book Depth",
      "orderBook.depthChart": "Depth Chart",
      "orderBook.bids": "Bids",
      "orderBook.asks": "Asks",
      "orderBook.spread": "Spread",
      "orderBook.midPrice": "Mid Price",
      "orderBook.bestBid": "Best Bid",
      "orderBook.bestAsk": "Best Ask",
      "orderBook.totalBidVol": "Total Bid Volume",
      "orderBook.totalAskVol": "Total Ask Volume",
      "orderBook.imbalance": "Imbalance",
      "orderBook.levels": "Levels",
      "orderBook.cumulative": "Cumulative",
      "orderBook.loading": "Loading depth...",
      "orderBook.noData": "No order book data",
      "orderBook.grouping": "Grouping",

      // Copy Trading
      "copyTrading.title": "Copy Trading",
      "copyTrading.subtitle": "Follow top traders and automatically copy their strategies",
      "copyTrading.leaderboard": "Top Traders Leaderboard",
      "copyTrading.yourTraders": "Your Traders",
      "copyTrading.follow": "Copy",
      "copyTrading.following": "Following",
      "copyTrading.cloneSettings": "Clone Settings",
      "copyTrading.unlock": "Unlock Copy Trading",
      "copyTrading.subscribe": "Subscribe to copy this trader",
      "copyTrading.paperInfo": "Paper Trading Mode — Copied trades will be simulated. No real funds at risk.",
      "copyTrading.liveInfo": "Live Trading Mode — Copied trades will execute on your connected exchange with real funds.",

      // Notifications
      "notifications.title": "Notifications",
      "notifications.push": "Push Notifications",
      "notifications.pushDesc": "Get browser notifications for trades, alerts, and bot activity",
      "notifications.enable": "Enable Notifications",
      "notifications.disable": "Disable Notifications",
      "notifications.enabled": "Push notifications enabled",
      "notifications.disabled": "Push notifications disabled",
      "notifications.tradeAlerts": "Trade Alerts",
      "notifications.botActivity": "Bot Activity",
      "notifications.priceAlerts": "Price Alerts",
      "notifications.bigMovers": "Big Movers",
      "notifications.systemUpdates": "System Updates",
      "notifications.markAllRead": "Mark all as read",
      "notifications.noNotifications": "No notifications yet",

      // Settings
      "settings.title": "Settings",
      "settings.language": "Language",
      "settings.languageDesc": "Choose your preferred language",
      "settings.theme": "Theme",
      "settings.profile": "Profile",
      "settings.security": "Security",
      "settings.exchanges": "Exchange API Keys",
      "settings.notifications": "Notification Preferences",

      // Performance
      "perf.title": "Performance",
      "perf.totalPnl": "Total P&L",
      "perf.winRate": "Win Rate",
      "perf.totalTrades": "Total Trades",
      "perf.avgTrade": "Avg Trade",
      "perf.bestTrade": "Best Trade",
      "perf.worstTrade": "Worst Trade",
    }
  },
  es: {
    translation: {
      "nav.dashboard": "Panel",
      "nav.portfolio": "Cartera",
      "nav.trade": "Comerciar",
      "nav.liveTrading": "Trading en Vivo",
      "nav.charts": "Graficos",
      "nav.bigMovers": "Grandes Movimientos",
      "nav.signalBots": "Bots de Senal",
      "nav.gridBots": "Bots Grid",
      "nav.dcaBots": "Bots DCA",
      "nav.smartTrades": "SmartTrades",
      "nav.paperTrading": "Trading Simulado",
      "nav.aiStrategy": "Estrategia IA",
      "nav.analytics": "Analiticas+",
      "nav.backtesting": "Backtesting",
      "nav.performance": "Rendimiento",
      "nav.copyTrading": "Copy Trading",
      "nav.settings": "Configuracion",
      "nav.rebalance": "Rebalancear",
      "nav.marketplace": "Mercado",
      "nav.journal": "Diario",
      "nav.referrals": "Referidos",
      "nav.admin": "Panel Admin",

      "common.loading": "Cargando...",
      "common.save": "Guardar",
      "common.cancel": "Cancelar",
      "common.delete": "Eliminar",
      "common.edit": "Editar",
      "common.search": "Buscar",
      "common.noData": "Sin datos disponibles",
      "common.success": "Exito",
      "common.error": "Error",
      "common.confirm": "Confirmar",
      "common.back": "Volver",
      "common.next": "Siguiente",
      "common.close": "Cerrar",
      "common.refresh": "Actualizar",
      "common.active": "Activo",
      "common.inactive": "Inactivo",

      "dashboard.title": "Panel",
      "dashboard.welcome": "Bienvenido de nuevo",
      "dashboard.totalBalance": "Balance Total",
      "dashboard.todayPnl": "P&L de Hoy",
      "dashboard.totalTrades": "Total de Operaciones",
      "dashboard.winRate": "Tasa de Exito",
      "dashboard.activeBots": "Bots Activos",

      "trading.buy": "Comprar",
      "trading.sell": "Vender",
      "trading.market": "Mercado",
      "trading.limit": "Limite",
      "trading.amount": "Cantidad",
      "trading.price": "Precio",
      "trading.placeOrder": "Colocar Orden",
      "trading.orderPlaced": "Orden colocada exitosamente",
      "trading.orderFailed": "La orden fallo",
      "trading.openOrders": "Ordenes Abiertas",
      "trading.tradeHistory": "Historial de Operaciones",
      "trading.pair": "Par de Trading",
      "trading.side": "Lado",
      "trading.orderType": "Tipo de Orden",
      "trading.stopLoss": "Stop Loss",
      "trading.takeProfit": "Take Profit",
      "trading.trailingStop": "Trailing Stop",
      "trading.oco": "OCO",
      "trading.realMoney": "DINERO REAL",
      "trading.paperMode": "Modo de Trading Simulado",
      "trading.liveMode": "Modo de Trading en Vivo",

      "liveTrade.title": "Trading en Vivo",
      "liveTrade.subtitle": "Ejecuta operaciones reales en tus exchanges conectados",
      "liveTrade.noExchanges": "Sin Exchanges Conectados",
      "liveTrade.noExchangesDesc": "Conecta tus claves API de exchange en Configuracion para empezar a operar.",
      "liveTrade.goToSettings": "Ir a Configuracion",
      "liveTrade.autoRefresh": "Auto-Actualizacion",
      "liveTrade.selectExchange": "Seleccionar Exchange",
      "liveTrade.balance": "Balance",
      "liveTrade.realWarning": "Esto ejecutara una operacion REAL con fondos REALES",

      "orderBook.title": "Profundidad del Libro de Ordenes",
      "orderBook.depthChart": "Grafico de Profundidad",
      "orderBook.bids": "Compras",
      "orderBook.asks": "Ventas",
      "orderBook.spread": "Spread",
      "orderBook.midPrice": "Precio Medio",
      "orderBook.bestBid": "Mejor Compra",
      "orderBook.bestAsk": "Mejor Venta",
      "orderBook.totalBidVol": "Volumen Total Compra",
      "orderBook.totalAskVol": "Volumen Total Venta",
      "orderBook.imbalance": "Desequilibrio",
      "orderBook.levels": "Niveles",
      "orderBook.cumulative": "Acumulativo",
      "orderBook.loading": "Cargando profundidad...",
      "orderBook.noData": "Sin datos del libro de ordenes",
      "orderBook.grouping": "Agrupacion",

      "copyTrading.title": "Copy Trading",
      "copyTrading.subtitle": "Sigue a los mejores traders y copia sus estrategias automaticamente",
      "copyTrading.leaderboard": "Tabla de Lideres",
      "copyTrading.yourTraders": "Tus Traders",
      "copyTrading.follow": "Copiar",
      "copyTrading.following": "Siguiendo",
      "copyTrading.cloneSettings": "Clonar Configuracion",
      "copyTrading.unlock": "Desbloquear Copy Trading",
      "copyTrading.subscribe": "Suscribete para copiar a este trader",
      "copyTrading.paperInfo": "Modo Simulado — Las operaciones copiadas seran simuladas. Sin riesgo de fondos reales.",
      "copyTrading.liveInfo": "Modo en Vivo — Las operaciones copiadas se ejecutaran en tu exchange conectado con fondos reales.",

      "notifications.title": "Notificaciones",
      "notifications.push": "Notificaciones Push",
      "notifications.pushDesc": "Recibe notificaciones del navegador para operaciones, alertas y actividad de bots",
      "notifications.enable": "Activar Notificaciones",
      "notifications.disable": "Desactivar Notificaciones",
      "notifications.enabled": "Notificaciones push activadas",
      "notifications.disabled": "Notificaciones push desactivadas",
      "notifications.tradeAlerts": "Alertas de Operaciones",
      "notifications.botActivity": "Actividad de Bots",
      "notifications.priceAlerts": "Alertas de Precio",
      "notifications.bigMovers": "Grandes Movimientos",
      "notifications.systemUpdates": "Actualizaciones del Sistema",
      "notifications.markAllRead": "Marcar todo como leido",
      "notifications.noNotifications": "Sin notificaciones aun",

      "settings.title": "Configuracion",
      "settings.language": "Idioma",
      "settings.languageDesc": "Elige tu idioma preferido",
      "settings.theme": "Tema",
      "settings.profile": "Perfil",
      "settings.security": "Seguridad",
      "settings.exchanges": "Claves API de Exchange",
      "settings.notifications": "Preferencias de Notificacion",

      "perf.title": "Rendimiento",
      "perf.totalPnl": "P&L Total",
      "perf.winRate": "Tasa de Exito",
      "perf.totalTrades": "Total de Operaciones",
      "perf.avgTrade": "Operacion Promedio",
      "perf.bestTrade": "Mejor Operacion",
      "perf.worstTrade": "Peor Operacion",
    }
  },
  fr: {
    translation: {
      "nav.dashboard": "Tableau de bord",
      "nav.portfolio": "Portefeuille",
      "nav.trade": "Trader",
      "nav.liveTrading": "Trading en direct",
      "nav.charts": "Graphiques",
      "nav.bigMovers": "Grands mouvements",
      "nav.signalBots": "Bots de signal",
      "nav.gridBots": "Bots Grid",
      "nav.dcaBots": "Bots DCA",
      "nav.smartTrades": "SmartTrades",
      "nav.paperTrading": "Trading simule",
      "nav.aiStrategy": "Strategie IA",
      "nav.analytics": "Analytiques+",
      "nav.backtesting": "Backtesting",
      "nav.performance": "Performance",
      "nav.copyTrading": "Copy Trading",
      "nav.settings": "Parametres",
      "nav.rebalance": "Reequilibrer",
      "nav.marketplace": "Marche",
      "nav.journal": "Journal",
      "nav.referrals": "Parrainages",
      "nav.admin": "Panneau Admin",

      "common.loading": "Chargement...",
      "common.save": "Enregistrer",
      "common.cancel": "Annuler",
      "common.delete": "Supprimer",
      "common.edit": "Modifier",
      "common.search": "Rechercher",
      "common.noData": "Aucune donnee disponible",
      "common.success": "Succes",
      "common.error": "Erreur",
      "common.confirm": "Confirmer",
      "common.back": "Retour",
      "common.next": "Suivant",
      "common.close": "Fermer",
      "common.refresh": "Rafraichir",
      "common.active": "Actif",
      "common.inactive": "Inactif",

      "dashboard.title": "Tableau de bord",
      "dashboard.welcome": "Bon retour",
      "dashboard.totalBalance": "Solde total",
      "dashboard.todayPnl": "P&L du jour",
      "dashboard.totalTrades": "Total des trades",
      "dashboard.winRate": "Taux de reussite",
      "dashboard.activeBots": "Bots actifs",

      "trading.buy": "Acheter",
      "trading.sell": "Vendre",
      "trading.market": "Marche",
      "trading.limit": "Limite",
      "trading.amount": "Montant",
      "trading.price": "Prix",
      "trading.placeOrder": "Passer l'ordre",
      "trading.orderPlaced": "Ordre passe avec succes",
      "trading.orderFailed": "L'ordre a echoue",
      "trading.openOrders": "Ordres ouverts",
      "trading.tradeHistory": "Historique des trades",
      "trading.pair": "Paire de trading",
      "trading.side": "Cote",
      "trading.orderType": "Type d'ordre",
      "trading.stopLoss": "Stop Loss",
      "trading.takeProfit": "Take Profit",
      "trading.trailingStop": "Trailing Stop",
      "trading.oco": "OCO",
      "trading.realMoney": "ARGENT REEL",
      "trading.paperMode": "Mode trading simule",
      "trading.liveMode": "Mode trading en direct",

      "liveTrade.title": "Trading en direct",
      "liveTrade.subtitle": "Executez des trades reels sur vos exchanges connectes",
      "liveTrade.noExchanges": "Aucun exchange connecte",
      "liveTrade.noExchangesDesc": "Connectez vos cles API d'exchange dans les Parametres pour commencer.",
      "liveTrade.goToSettings": "Aller aux Parametres",
      "liveTrade.autoRefresh": "Auto-actualisation",
      "liveTrade.selectExchange": "Choisir l'exchange",
      "liveTrade.balance": "Solde",
      "liveTrade.realWarning": "Ceci executera un trade REEL avec des fonds REELS",

      "orderBook.title": "Profondeur du carnet d'ordres",
      "orderBook.depthChart": "Graphique de profondeur",
      "orderBook.bids": "Achats",
      "orderBook.asks": "Ventes",
      "orderBook.spread": "Spread",
      "orderBook.midPrice": "Prix median",
      "orderBook.bestBid": "Meilleur achat",
      "orderBook.bestAsk": "Meilleure vente",
      "orderBook.totalBidVol": "Volume total achat",
      "orderBook.totalAskVol": "Volume total vente",
      "orderBook.imbalance": "Desequilibre",
      "orderBook.levels": "Niveaux",
      "orderBook.cumulative": "Cumulatif",
      "orderBook.loading": "Chargement de la profondeur...",
      "orderBook.noData": "Aucune donnee du carnet d'ordres",
      "orderBook.grouping": "Regroupement",

      "copyTrading.title": "Copy Trading",
      "copyTrading.subtitle": "Suivez les meilleurs traders et copiez automatiquement leurs strategies",
      "copyTrading.leaderboard": "Classement des meilleurs traders",
      "copyTrading.yourTraders": "Vos traders",
      "copyTrading.follow": "Copier",
      "copyTrading.following": "Suivi",
      "copyTrading.cloneSettings": "Cloner les parametres",
      "copyTrading.unlock": "Debloquer le Copy Trading",
      "copyTrading.subscribe": "Abonnez-vous pour copier ce trader",
      "copyTrading.paperInfo": "Mode simule — Les trades copies seront simules. Aucun risque pour vos fonds.",
      "copyTrading.liveInfo": "Mode en direct — Les trades copies seront executes sur votre exchange avec des fonds reels.",

      "notifications.title": "Notifications",
      "notifications.push": "Notifications Push",
      "notifications.pushDesc": "Recevez des notifications du navigateur pour les trades, alertes et activite des bots",
      "notifications.enable": "Activer les notifications",
      "notifications.disable": "Desactiver les notifications",
      "notifications.enabled": "Notifications push activees",
      "notifications.disabled": "Notifications push desactivees",
      "notifications.tradeAlerts": "Alertes de trades",
      "notifications.botActivity": "Activite des bots",
      "notifications.priceAlerts": "Alertes de prix",
      "notifications.bigMovers": "Grands mouvements",
      "notifications.systemUpdates": "Mises a jour systeme",
      "notifications.markAllRead": "Tout marquer comme lu",
      "notifications.noNotifications": "Aucune notification",

      "settings.title": "Parametres",
      "settings.language": "Langue",
      "settings.languageDesc": "Choisissez votre langue preferee",
      "settings.theme": "Theme",
      "settings.profile": "Profil",
      "settings.security": "Securite",
      "settings.exchanges": "Cles API d'exchange",
      "settings.notifications": "Preferences de notification",

      "perf.title": "Performance",
      "perf.totalPnl": "P&L total",
      "perf.winRate": "Taux de reussite",
      "perf.totalTrades": "Total des trades",
      "perf.avgTrade": "Trade moyen",
      "perf.bestTrade": "Meilleur trade",
      "perf.worstTrade": "Pire trade",
    }
  },
  zh: {
    translation: {
      "nav.dashboard": "仪表板",
      "nav.portfolio": "投资组合",
      "nav.trade": "交易",
      "nav.liveTrading": "实盘交易",
      "nav.charts": "图表",
      "nav.bigMovers": "热门行情",
      "nav.signalBots": "信号机器人",
      "nav.gridBots": "网格机器人",
      "nav.dcaBots": "DCA机器人",
      "nav.smartTrades": "智能交易",
      "nav.paperTrading": "模拟交易",
      "nav.aiStrategy": "AI策略",
      "nav.analytics": "高级分析",
      "nav.backtesting": "回测",
      "nav.performance": "绩效",
      "nav.copyTrading": "跟单交易",
      "nav.settings": "设置",
      "nav.rebalance": "再平衡",
      "nav.marketplace": "市场",
      "nav.journal": "交易日志",
      "nav.referrals": "推荐",
      "nav.admin": "管理面板",

      "common.loading": "加载中...",
      "common.save": "保存",
      "common.cancel": "取消",
      "common.delete": "删除",
      "common.edit": "编辑",
      "common.search": "搜索",
      "common.noData": "暂无数据",
      "common.success": "成功",
      "common.error": "错误",
      "common.confirm": "确认",
      "common.back": "返回",
      "common.next": "下一步",
      "common.close": "关闭",
      "common.refresh": "刷新",
      "common.active": "活跃",
      "common.inactive": "未活跃",

      "dashboard.title": "仪表板",
      "dashboard.welcome": "欢迎回来",
      "dashboard.totalBalance": "总余额",
      "dashboard.todayPnl": "今日盈亏",
      "dashboard.totalTrades": "总交易数",
      "dashboard.winRate": "胜率",
      "dashboard.activeBots": "活跃机器人",

      "trading.buy": "买入",
      "trading.sell": "卖出",
      "trading.market": "市价",
      "trading.limit": "限价",
      "trading.amount": "数量",
      "trading.price": "价格",
      "trading.placeOrder": "下单",
      "trading.orderPlaced": "订单已成功下达",
      "trading.orderFailed": "订单失败",
      "trading.openOrders": "未完成订单",
      "trading.tradeHistory": "交易历史",
      "trading.pair": "交易对",
      "trading.side": "方向",
      "trading.orderType": "订单类型",
      "trading.stopLoss": "止损",
      "trading.takeProfit": "止盈",
      "trading.trailingStop": "追踪止损",
      "trading.oco": "OCO",
      "trading.realMoney": "真实资金",
      "trading.paperMode": "模拟交易模式",
      "trading.liveMode": "实盘交易模式",

      "liveTrade.title": "实盘交易",
      "liveTrade.subtitle": "在您连接的交易所上执行真实交易",
      "liveTrade.noExchanges": "未连接交易所",
      "liveTrade.noExchangesDesc": "在设置中连接您的交易所API密钥以开始实盘交易。",
      "liveTrade.goToSettings": "前往设置",
      "liveTrade.autoRefresh": "自动刷新",
      "liveTrade.selectExchange": "选择交易所",
      "liveTrade.balance": "余额",
      "liveTrade.realWarning": "这将使用真实资金执行真实交易",

      "orderBook.title": "订单簿深度",
      "orderBook.depthChart": "深度图",
      "orderBook.bids": "买单",
      "orderBook.asks": "卖单",
      "orderBook.spread": "价差",
      "orderBook.midPrice": "中间价",
      "orderBook.bestBid": "最优买价",
      "orderBook.bestAsk": "最优卖价",
      "orderBook.totalBidVol": "买单总量",
      "orderBook.totalAskVol": "卖单总量",
      "orderBook.imbalance": "失衡",
      "orderBook.levels": "档位",
      "orderBook.cumulative": "累计",
      "orderBook.loading": "加载深度数据...",
      "orderBook.noData": "暂无订单簿数据",
      "orderBook.grouping": "分组",

      "copyTrading.title": "跟单交易",
      "copyTrading.subtitle": "跟随顶级交易者并自动复制其策略",
      "copyTrading.leaderboard": "顶级交易者排行榜",
      "copyTrading.yourTraders": "你的交易者",
      "copyTrading.follow": "跟单",
      "copyTrading.following": "已跟随",
      "copyTrading.cloneSettings": "克隆设置",
      "copyTrading.unlock": "解锁跟单交易",
      "copyTrading.subscribe": "订阅以跟单此交易者",
      "copyTrading.paperInfo": "模拟模式 — 跟单交易将被模拟，无真实资金风险。",
      "copyTrading.liveInfo": "实盘模式 — 跟单交易将在您连接的交易所上使用真实资金执行。",

      "notifications.title": "通知",
      "notifications.push": "推送通知",
      "notifications.pushDesc": "接收交易、警报和机器人活动的浏览器通知",
      "notifications.enable": "启用通知",
      "notifications.disable": "禁用通知",
      "notifications.enabled": "推送通知已启用",
      "notifications.disabled": "推送通知已禁用",
      "notifications.tradeAlerts": "交易警报",
      "notifications.botActivity": "机器人活动",
      "notifications.priceAlerts": "价格警报",
      "notifications.bigMovers": "热门行情",
      "notifications.systemUpdates": "系统更新",
      "notifications.markAllRead": "全部标记为已读",
      "notifications.noNotifications": "暂无通知",

      "settings.title": "设置",
      "settings.language": "语言",
      "settings.languageDesc": "选择您的首选语言",
      "settings.theme": "主题",
      "settings.profile": "个人资料",
      "settings.security": "安全",
      "settings.exchanges": "交易所API密钥",
      "settings.notifications": "通知偏好",

      "perf.title": "绩效",
      "perf.totalPnl": "总盈亏",
      "perf.winRate": "胜率",
      "perf.totalTrades": "总交易数",
      "perf.avgTrade": "平均交易",
      "perf.bestTrade": "最佳交易",
      "perf.worstTrade": "最差交易",
    }
  },
  ja: {
    translation: {
      "nav.dashboard": "ダッシュボード",
      "nav.portfolio": "ポートフォリオ",
      "nav.trade": "取引",
      "nav.liveTrading": "ライブ取引",
      "nav.charts": "チャート",
      "nav.bigMovers": "注目銘柄",
      "nav.signalBots": "シグナルボット",
      "nav.copyTrading": "コピートレード",
      "nav.paperTrading": "ペーパートレード",
      "nav.settings": "設定",
      "nav.performance": "パフォーマンス",

      "common.loading": "読み込み中...",
      "common.save": "保存",
      "common.cancel": "キャンセル",
      "common.search": "検索",
      "common.noData": "データがありません",
      "common.success": "成功",
      "common.error": "エラー",

      "trading.buy": "買い",
      "trading.sell": "売り",
      "trading.placeOrder": "注文する",
      "trading.amount": "数量",
      "trading.price": "価格",

      "settings.language": "言語",
      "settings.languageDesc": "お好みの言語を選択してください",
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;

export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English', flag: 'EN' },
  { code: 'es', name: 'Espanol', flag: 'ES' },
  { code: 'fr', name: 'Francais', flag: 'FR' },
  { code: 'zh', name: '中文', flag: 'ZH' },
  { code: 'ja', name: '日本語', flag: 'JA' },
];
